import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";
import { RatesContext } from "../Pages/RatesContext";

function UpdateDailyRates() {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const { updateRates } = useContext(RatesContext); // Access updateRates from context

  const [updateData, setUpdateData] = useState({
    gold_1g_rate: "",
    cold_coin_rate: "",
    gold_pure_percentage: "",
    silver_10g_rate: "",
    silver_coin_rate: "",
    silver_pure_percentage: "",
    date: "",
    time: "",
    created_by: "",
    created_date: "",
    updated_by: "",
  });

  const [currentRates, setCurrentRates] = useState({
    goldRate: "",
    silverRate: "",
    lastUpdated: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const formatTimeWithAMPM = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(":").map(Number);
    if (isNaN(hours) || isNaN(minutes)) return timeString;
    const period = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12; // Convert 0 to 12 for 12 AM
    return `${hours12}:${minutes.toString().padStart(2, "0")} ${period}`;
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/daily_rates.php/${id}`);
      const responseData = response.data.data[0];

      let formattedDate = "";
      if (responseData.date) {
        const dateParts = responseData.date.split("-");
        if (dateParts.length === 3) {
          formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        }
      }

      setUpdateData({
        gold_1g_rate: responseData.gold_1g_rate || "",
        cold_coin_rate: responseData.cold_coin_rate || "",
        gold_pure_percentage: responseData.gold_pure_percentage || "",
        silver_10g_rate: responseData.silver_10g_rate || "",
        silver_coin_rate: responseData.silver_coin_rate || "",
        silver_pure_percentage: responseData.silver_pure_percentage || "",
        date: formattedDate,
        time: responseData.time || "",
        created_by: responseData.created_by || "",
        created_date: responseData.created_date || "",
        updated_by: responseData.updated_by || "",
      });

      const formattedTime = formatTimeWithAMPM(responseData.time);

      setCurrentRates({
        goldRate: responseData.gold_1g_rate || "",
        silverRate: responseData.silver_10g_rate
          ? parseFloat(responseData.silver_10g_rate).toFixed(0) // no division
          : "",
        lastUpdated: `${formattedDate} ${formattedTime}`.trim(),
      });
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      const inputDate = updateData.date;
      const formattedDate = inputDate
        ? inputDate.split("-").reverse().join("-")
        : "";

      // Get current time in HH:mm format
      const now = new Date();
      const currentTime = `${now.getHours().toString().padStart(2, "0")}:${now
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;

      const formData = {
        gold_1g_rate: updateData.gold_1g_rate,
        cold_coin_rate: updateData.cold_coin_rate,
        gold_pure_percentage: updateData.gold_pure_percentage,
        silver_10g_rate: updateData.silver_10g_rate,
        silver_coin_rate: updateData.silver_coin_rate,
        silver_pure_percentage: updateData.silver_pure_percentage,
        date: formattedDate,
        time: currentTime, // Set to current time
        created_by: updateData.created_by,
        created_date: updateData.created_date,
        updated_by: "admin",
        updated_date: new Date()
          .toISOString()
          .split("T")[0]
          .split("-")
          .reverse()
          .join("-"),
      };

      const response = await axios.put(
        `${ApiUrl}/Api/daily_rates.php/${id}`,
        formData
      );

      // Update context with new rates
      updateRates({
        gold_1g_rate: updateData.gold_1g_rate,
        silver_10g_rate: updateData.silver_10g_rate,
      });

      navigate("/daily-rates");
      toast.success("Updated Successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error updating data:", error.message);
      toast.error(`Failed to update rates: ${error.message}`, 3000, "topRight");
    }
  };

  return (
    <div className="container-fluid py-3 mb-5">
      <div className="card p-3">
        <div className="d-flex justify-content-between align-items-center mb-1">
          <h6>Update Today's Rates</h6>
          <div className="d-flex align-items-center ms-auto">
            <div className="d-flex align-items-center me-3 m-2">
              <label htmlFor="date" className="me-2">
                Date:
              </label>
              <input
                type="date"
                className="form-control m-2"
                value={updateData.date}
                onChange={(e) =>
                  setUpdateData({ ...updateData, date: e.target.value })
                }
              />
            </div>
            <div className="d-flex align-items-center">
              <label htmlFor="time" className="me-2">
                Time:
              </label>
              <input
                type="time"
                className="form-control m-2"
                value={updateData.time}
                onChange={(e) =>
                  setUpdateData({ ...updateData, time: e.target.value })
                }
              />
            </div>
          </div>
        </div>

        <div className="card mt-2 bg-warning bg-opacity-10">
          <div className="card-body">
            <div className="row text-center">
              <div className="col-md-4">
                <h6>Last Updated Gold Rate</h6>
                <p>
                  <span className="mx-1">₹</span>
                  {currentRates.goldRate}/ 1 gram
                </p>
              </div>
              <div className="col-md-4">
                <h6>Last Updated Silver Rate</h6>
                <p>
                  <span className="mx-1">₹</span>
                  {currentRates.silverRate}/ 1 gram
                  {console.log("the data was", currentRates.silverRate)}
                </p>
              </div>
              <div className="col-md-4">
                <h6>Last Updated Date & Time</h6>
                <p>{currentRates.lastUpdated}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-md-6">
            <div className="card">
              <div className="card-header bg-white">
                <h6 className="mb-0 text-primary text-center">Gold Rates</h6>
              </div>
              <div className="card-body">
                <div>
                  <label className="form-label">Gold 1g-Rate</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    pattern="[0-9]+(\.[0-9]*)?"
                    className="form-control rounded-pill"
                    value={updateData.gold_1g_rate}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d*$/.test(value)) {
                        setUpdateData({ ...updateData, gold_1g_rate: value });
                      }
                    }}
                    placeholder="Enter Gold 1g-Rate"
                    required
                  />
                </div>
                <div>
                  <label className="form-label">Gold Coin-Rate</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    pattern="[0-9]+(\.[0-9]*)?"
                    className="form-control rounded-pill"
                    value={updateData.cold_coin_rate}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d*$/.test(value)) {
                        setUpdateData({ ...updateData, cold_coin_rate: value });
                      }
                    }}
                    placeholder="Enter Gold Coin-Rate"
                    required
                  />
                </div>
                <div>
                  <label className="form-label">Gold Pure Rate</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    pattern="[0-9]+(\.[0-9]*)?"
                    className="form-control rounded-pill"
                    value={updateData.gold_pure_percentage}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d*$/.test(value)) {
                        setUpdateData({
                          ...updateData,
                          gold_pure_percentage: value,
                        });
                      }
                    }}
                    placeholder="Enter Gold Pure Rate"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card">
              <div className="card-header bg-white">
                <h6 className="mb-0 text-primary text-center">Silver Rates</h6>
              </div>
              <div className="card-body">
                 <div>
                  <label className="form-label">Silver 1g-Rate</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    pattern="[0-9]+(\.[0-9]*)?"
                    className="form-control rounded-pill"
                    id="silver10g"
                    name="silver10g"
                    value={updateData.silver_10g_rate}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d*$/.test(value)) {
                        setUpdateData({
                          ...updateData,
                          silver_10g_rate: value,
                        });
                      }
                    }}
                    placeholder="Enter Silver 1g-Rate"
                    required
                  />
                </div>
                <div>
                  <label className="form-label">Silver Coin-Rate</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    pattern="[0-9]+(\.[0-9]*)?"
                    className="form-control rounded-pill"
                    id="silverCoin"
                    name="silverCoin"
                    value={updateData.silver_coin_rate}
                    onChange={(e) => {
                      const value = e.target.value;
                     if (/^\d*\.?\d*$/.test(value)) {
                        setUpdateData({
                          ...updateData,
                          silver_coin_rate: value,
                        });
                      }
                    }}
                    placeholder="Enter Silver Coin-Rate"
                    required
                  />
                </div>
                <div>
                  <label className="form-label">Silver Pure Rate</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    pattern="[0-9]+(\.[0-9]*)?"
                    className="form-control rounded-pill"
                    id="silverPurePercentage"
                    name="silverPurePercentage"
                    value={updateData.silver_pure_percentage}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d*$/.test(value)) {
                        setUpdateData({
                          ...updateData,
                          silver_pure_percentage: value,
                        });
                      }
                    }}
                    placeholder="Enter Silver Pure Rate"
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center mt-2">
          <button
            className="btn btn-secondary"
            style={{ fontSize: "14px", fontWeight: "600" }}
            onClick={() => navigate("/daily-rates")}
          >
            Back
          </button>
          <button
            className="btn btn-primary mx-2"
            style={{ fontSize: "14px", fontWeight: "600" }}
            onClick={handleupdatesubmit}
          >
            Update Daily Rates
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateDailyRates;
